"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _index = _interopRequireDefault(require("../animation/motion-parallax/index"));
var _scrollContext = require("../animation/motion-parallax/scroll-context");
var _videoLightbox = _interopRequireDefault(require("../../page-body/media-components/video-lightbox"));
var _stickySection = _interopRequireDefault(require("./sticky-section"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _scrollableSection = _interopRequireDefault(require("./scrollable-section"));
var _stickyBackgroundSection = _interopRequireDefault(require("./sticky-background-section"));
var _marqueeFunctions = require("./marquee-functions");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _useElementProps = _interopRequireDefault(require("@site/pattern-library-utils/hooks/useElementProps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Container = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "Container",
  class: "pl-c19eh2w5"
});
const SectionContainer = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "SectionContainer",
  class: "pl-s1b8sc05"
});
const SinglePanelContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SinglePanelContainer",
  class: "pl-s15eavs1",
  vars: {
    "s15eavs1-0": [({
      navHeights
    }) => `calc(100vh - (${navHeights?.desktop || 0}px + var(--primary-nav-height)))`],
    "s15eavs1-1": [({
      navHeights
    }) => `calc(100svh - (${navHeights?.mobile || 0}px + var(--primary-nav-height)))`],
    "s15eavs1-3": [({
      navHeights
    }) => `calc(100svh - (${navHeights?.desktop || 0}px + var(--primary-nav-height)))`]
  }
});

/**
 * MotionCampaignMarquee component
 *
 * @param {Object} props Component properties
 * @param {string} props.id Unique identifier for the component
 * @param {string} props._name Name of the component
 * @param {string} props.layout Layout mode ('default' or 'single-panel')
 * @param {Object} props.portrait Portrait image object
 * @param {Object} props.landscape Landscape image object
 * @param {string} props.youTubeId YouTube video ID
 * @param {string} props.lightboxUrl URL for the lightbox video
 * @param {boolean} props.transcriptButton Flag to show transcript button
 * @param {string} props.ariaLabelCloseButton ARIA label for the close button
 * @param {boolean} props.disableAutoPlay Flag to disable auto-play
 * @param {string} props.playButtonText Text for the play button
 * @param {string} props.thumbnailDesktop URL for the desktop thumbnail
 * @param {string} props.thumbnailMobile URL for the mobile thumbnail
 * @param {string} props.introUrl URL for the intro video
 * @param {string} props.introUrlWebm URL for the intro video in WebM format
 * @param {string} props.introUrlLaptop URL for the laptop intro video
 * @param {string} props.introUrlLaptopWebm URL for the laptop intro video in WebM format
 * @param {Node} props.videos React node with Bynder video sources
 * @param {string} props.preload Preload setting for the video
 * @param {string} props.stickyPanelText Text for the sticky panel
 * @param {Object} props.stickyPanelInlineImage1 First inline image object for the sticky panel
 * @param {Object} props.stickyPanelInlineImage2 Second inline image object for the sticky panel
 * @param {Object} props.stickyPanelInlineImage3 Third inline image object for the sticky panel
 * @param {Object|Node} props.offerBanner Offer banner object or React node
 * @param {Object|Node} props.headlineLockup Headline lockup object or React node
 * @param {Object} props.headlineProps Properties for the headline
 * @param {boolean} props.noBannerOnMobile Flag to hide the offer banner on mobile
 *
 * @returns {JSX.Element} MotionCampaignMarquee component
 */
function MotionCampaignMarquee({
  id,
  _name,
  layout = 'default',
  portrait,
  landscape,
  youTubeId,
  lightboxUrl,
  transcriptButton,
  ariaLabelCloseButton,
  disableAutoPlay,
  playButtonText,
  thumbnailDesktop,
  thumbnailMobile,
  introUrl,
  introUrlWebm,
  introUrlLaptop,
  introUrlLaptopWebm,
  videos,
  preload,
  stickyPanelText,
  stickyPanelInlineImage1,
  stickyPanelInlineImage2,
  stickyPanelInlineImage3,
  offerBanner,
  headlineLockup,
  insetTop,
  navElements = '',
  noBannerOnMobile = false,
  ...headlineProps
}) {
  const {
    mobileHeight,
    desktopHeight
  } = (0, _marqueeFunctions.calculateNavHeights)(navElements);
  const [lightBoxIsOpen, setLightBoxIsOpen] = (0, _react.useState)(false);
  const openLightBox = () => setLightBoxIsOpen(true);
  const closeLightBox = () => setLightBoxIsOpen(false);
  const processedOfferBanner = (0, _useElementProps.default)(offerBanner, {
    playButtonText,
    openLightBox
  });
  const processedHeadlineLockup = (0, _useElementProps.default)(headlineLockup, {
    headlineSize: headlineLockup?.props?.headlineSize || headlineProps.headlineSize || 'h2',
    fontType: 'text',
    textAlign: 'center',
    actionsLayout: 'button-set'
  });
  const isSinglePanel = layout === 'single-panel';
  if (isSinglePanel) {
    return /*#__PURE__*/_react.default.createElement(Container, {
      id: `id-${id}`,
      _name: _name,
      dataCy: "motion-campaign-marquee",
      padding: "none",
      verticalMargin: "none",
      verticalPadding: "none",
      showOverflow: true
    }, /*#__PURE__*/_react.default.createElement(SinglePanelContainer, {
      navHeights: {
        mobile: mobileHeight,
        desktop: desktopHeight
      }
    }, /*#__PURE__*/_react.default.createElement(_stickyBackgroundSection.default, {
      transformY: 0,
      introUrl: introUrl,
      introUrlWebm: introUrlWebm,
      introUrlLaptop: introUrlLaptop,
      introUrlLaptopWebm: introUrlLaptopWebm,
      thumbnailDesktop: thumbnailDesktop,
      thumbnailMobile: thumbnailMobile,
      videos: videos,
      preload: preload,
      portrait: portrait,
      landscape: landscape,
      insetTop: insetTop,
      navHeights: {
        mobile: mobileHeight,
        desktop: desktopHeight
      },
      isSinglePanel: true
    }), /*#__PURE__*/_react.default.createElement(_scrollableSection.default, {
      headlineProps: headlineProps,
      headlineLockup: processedHeadlineLockup,
      playButtonText: playButtonText,
      openLightBox: openLightBox,
      offerBanner: processedOfferBanner,
      navHeights: {
        mobile: mobileHeight,
        desktop: desktopHeight
      },
      noBannerOnMobile: noBannerOnMobile
    })), (lightboxUrl || youTubeId) && /*#__PURE__*/_react.default.createElement(_videoLightbox.default, {
      youTubeId,
      lightboxUrl,
      showModal: lightBoxIsOpen,
      handleClose: closeLightBox,
      transcriptButton,
      ariaLabelCloseButton,
      disableAutoPlay
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_scrollContext.ScrollProvider, null, /*#__PURE__*/_react.default.createElement(Container, {
    id: `id-${id}`,
    _name: _name,
    dataCy: "motion-campaign-marquee",
    padding: "none",
    verticalMargin: "none",
    verticalPadding: "none",
    showOverflow: true
  }, /*#__PURE__*/_react.default.createElement(SectionContainer, {
    id: "translate-y",
    settings: {
      speed: 1,
      maxTransformValue: 25
    }
  }, ({
    transformY
  }) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_stickyBackgroundSection.default, {
    transformY: transformY,
    introUrl: introUrl,
    introUrlWebm: introUrlWebm,
    introUrlLaptop: introUrlLaptop,
    introUrlLaptopWebm: introUrlLaptopWebm,
    thumbnailDesktop: thumbnailDesktop,
    thumbnailMobile: thumbnailMobile,
    videos: videos,
    preload: preload,
    portrait: portrait,
    landscape: landscape,
    insetTop: insetTop,
    navHeights: {
      mobile: mobileHeight,
      desktop: desktopHeight
    },
    isSinglePanel: false
  }), /*#__PURE__*/_react.default.createElement(_scrollableSection.default, {
    headlineProps: headlineProps,
    headlineLockup: processedHeadlineLockup,
    playButtonText: playButtonText,
    openLightBox: openLightBox,
    offerBanner: processedOfferBanner,
    navHeights: {
      mobile: mobileHeight,
      desktop: desktopHeight
    },
    noBannerOnMobile: noBannerOnMobile
  }), /*#__PURE__*/_react.default.createElement(_stickySection.default, {
    text: stickyPanelText,
    inlineImage1: stickyPanelInlineImage1,
    inlineImage2: stickyPanelInlineImage2,
    inlineImage3: stickyPanelInlineImage3
  }))), (lightboxUrl || youTubeId) && /*#__PURE__*/_react.default.createElement(_videoLightbox.default, {
    youTubeId,
    lightboxUrl,
    showModal: lightBoxIsOpen,
    handleClose: closeLightBox,
    transcriptButton,
    ariaLabelCloseButton,
    disableAutoPlay
  })));
}
var _default = exports.default = MotionCampaignMarquee;
MotionCampaignMarquee.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  layout: _propTypes.default.oneOf(['default', 'single-panel']),
  portrait: _propTypes.default.object,
  landscape: _propTypes.default.object,
  youTubeId: _propTypes.default.string,
  lightboxUrl: _propTypes.default.string,
  transcriptButton: _propTypes.default.bool,
  ariaLabelCloseButton: _propTypes.default.string,
  disableAutoPlay: _propTypes.default.bool,
  playButtonText: _propTypes.default.string,
  thumbnailDesktop: _propTypes.default.string,
  thumbnailMobile: _propTypes.default.string,
  introUrl: _propTypes.default.string,
  introUrlWebm: _propTypes.default.string,
  introUrlLaptop: _propTypes.default.string,
  introUrlLaptopWebm: _propTypes.default.string,
  videos: _propTypes.default.node,
  preload: _propTypes.default.string,
  stickyPanelText: _propTypes.default.string,
  offerBanner: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  headlineLockup: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  headlineProps: _propTypes.default.object,
  stickyPanelInlineImage1: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  stickyPanelInlineImage2: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  stickyPanelInlineImage3: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string
  }),
  insetTop: _propTypes.default.bool,
  navElements: _propTypes.default.oneOfType(['tld-searchbar', 'secondary-nav']),
  noBannerOnMobile: _propTypes.default.bool
};